/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_ViInputs */

const en_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const es_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const de_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const zh_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const ar_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const fr_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const vi_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const sw_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const th_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const bs_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const ja_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const ko_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const pt_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const it_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const sv_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const nl_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const da_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const nb_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const fi_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const pl_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const ru_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const tr_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const hi_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const id_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const ms_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const cs_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const el_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const he_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const af_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

const hu_nav_language_vi = /** @type {(inputs: Nav_Language_ViInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếng Việt`)
};

/**
* | output |
* | --- |
* | "Tiếng Việt" |
*
* @param {Nav_Language_ViInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_vi = /** @type {((inputs?: Nav_Language_ViInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_ViInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_vi(inputs)
	if (locale === "de") return de_nav_language_vi(inputs)
	if (locale === "zh") return zh_nav_language_vi(inputs)
	if (locale === "ar") return ar_nav_language_vi(inputs)
	if (locale === "fr") return fr_nav_language_vi(inputs)
	if (locale === "vi") return vi_nav_language_vi(inputs)
	if (locale === "sw") return sw_nav_language_vi(inputs)
	if (locale === "th") return th_nav_language_vi(inputs)
	if (locale === "bs") return bs_nav_language_vi(inputs)
	if (locale === "ja") return ja_nav_language_vi(inputs)
	if (locale === "ko") return ko_nav_language_vi(inputs)
	if (locale === "pt") return pt_nav_language_vi(inputs)
	if (locale === "it") return it_nav_language_vi(inputs)
	if (locale === "sv") return sv_nav_language_vi(inputs)
	if (locale === "nl") return nl_nav_language_vi(inputs)
	if (locale === "da") return da_nav_language_vi(inputs)
	if (locale === "nb") return nb_nav_language_vi(inputs)
	if (locale === "fi") return fi_nav_language_vi(inputs)
	if (locale === "pl") return pl_nav_language_vi(inputs)
	if (locale === "ru") return ru_nav_language_vi(inputs)
	if (locale === "tr") return tr_nav_language_vi(inputs)
	if (locale === "hi") return hi_nav_language_vi(inputs)
	if (locale === "id") return id_nav_language_vi(inputs)
	if (locale === "ms") return ms_nav_language_vi(inputs)
	if (locale === "cs") return cs_nav_language_vi(inputs)
	if (locale === "el") return el_nav_language_vi(inputs)
	if (locale === "he") return he_nav_language_vi(inputs)
	if (locale === "af") return af_nav_language_vi(inputs)
	if (locale === "hu") return hu_nav_language_vi(inputs)
	return en_nav_language_vi(inputs)
});